import { STORE_CONFIG } from "../constants/actionCreators";

const initialState = {}

export default (store, action) => {
  if (action.type === STORE_CONFIG) {
    return action.config;
  }
  return store || initialState;
};